import request from '../../functions/request'
import { useEffect, useState } from 'react'
import { eyeInvisibleSvg, eyeVisibleSvg } from './svg'
// @ts-ignore
import styles from './styles.scss'

export function desensitizeTransfer(params: any) {
  return request({
    uri: '/api/business/member/desensitize/transfer',
    params,
    method: 'POST',
  })
}

export interface IDesensiteProps {
  data: null |  string |{
    label: 'string'
    module: 'string'
    field: 'string'
    origin: 'string'
    data: 'string'
    sign: 'string'
  }
  isLineBreak?: boolean
}

export default function DesensitizationBox(
  props: IDesensiteProps = {
    data: null,
    isLineBreak: false,
  },
) {
  const { isLineBreak } = props || {}
  const { label, data } = props.data && typeof props.data === 'object' ? props.data : {}
  const [text, setText] = useState('')
  const [desensitizationText, setDesensitizationText] = useState('')
  // 脱敏词是否显示
  const [isShowDesensWord, setIsShowDesensWord] = useState(false)
  // 是否获取脱敏词
  const [hasDesensitization, setHasDesensitization] = useState(false)

  const getDesensitization = async () => {
    if (hasDesensitization && desensitizationText) {
      setIsShowDesensWord(true)
      return
    }
    const res: any = await desensitizeTransfer(props.data)
    setIsShowDesensWord(true)
    // setText(res)
    setDesensitizationText(res)
    setHasDesensitization(true)
  }

  useEffect(() => {
    if (label) setText(label)
  }, [label])

  if (!props.data) return <>-</>
  if (Object.prototype.toString.call(props.data) === '[object String]')
    return <>{props.data}</>


  return (
    <p
     
      className={styles.desensitizationBox}
    >
      {/* 脱敏词 */}
      {!isShowDesensWord && (
        <span style={isLineBreak ? { wordBreak: 'break-all' } : {}}>
          {text}
        </span>
      )}
      {/* 查看明文 */}
      {data && isShowDesensWord && <span>{desensitizationText}</span>}
      {data &&
        (isShowDesensWord ? (
          <div
            className={styles.eyeWrap}
            onClick={() => setIsShowDesensWord(false)}
          >
            <span className={styles.eyeIcon}
              dangerouslySetInnerHTML={{ __html: eyeVisibleSvg }}
            />
          </div>
        ) : (
          <div
            className={styles.eyeWrap}
            onClick={getDesensitization}
          >
            <span className={styles.eyeIcon}
              dangerouslySetInnerHTML={{ __html: eyeInvisibleSvg }}
            />
          </div>
        ))}
    </p>
  )
}
